import React, { Component } from 'react';
import Closest              from './../containers/ClosestContainer';
import Loading              from 'react-loading';
import './../css/Strap.css';

class StrapLine extends Component
{

    renderStrapLine() {
        if (!this.props.strapline)
        {
            return (<Loading type="bubbles" color="gray" width={50} height={50} />);
        }
        else
        {
            return (
                <div>
                    <p className="strap-text fs-18"><strong>{ this.props.strapline.title }</strong></p>
                    <div className="strap-text fs-14" dangerouslySetInnerHTML={{__html: this.props.strapline.body }} />
                </div>
            );
        }
    }

    renderClosest = () =>
    {
        return (
            <div className="strap-closest">
                <p className="strap-text fs-18">&nbsp;</p>
                <Closest />
                <p className="strap-text fs-14">&nbsp;</p>
            </div>
        );
    };
    
    render = () =>
    {
        let closest;
        let strapClass = 'strap';
        if (this.props.geo.watching)
        {
            closest    = this.renderClosest();
            strapClass = 'strap strap-short';
        }

        return (
            <div>
                <div className={ strapClass }>
                    { this.renderStrapLine() }
                </div>
                { closest }
            </div>
        );
    }
}

export default StrapLine;


// WEBPACK FOOTER //
// ./src/components/StrapLine.js